import React, { useCallback, useRef } from "react";
import axios from "axios";
import { API_ROUTES } from "../../constant";

const useSendOtp = () => {

    const requestOtp = useCallback(async (mobileNumber: string, language: string, action: string, userResendOtp: boolean) =>{
        // Use staging API URL from environment variable
        const apiUrl = process.env.REACT_APP_API_SIGNUP || process.env.REACT_APP_API_URL;
        
        if (!apiUrl) {
            console.error('REACT_APP_API_SIGNUP or REACT_APP_API_URL is not defined');
            throw new Error('API URL is not configured');
        }
        
        // Remove trailing slash from apiUrl and ensure API_ROUTES path starts with /
        const baseUrl = apiUrl.replace(/\/$/, '');
        const apiPath = API_ROUTES.REFERRAL_SEND_OTP.startsWith('/') 
            ? API_ROUTES.REFERRAL_SEND_OTP 
            : `/${API_ROUTES.REFERRAL_SEND_OTP}`;
        const fullUrl = `${baseUrl}${apiPath}`;
    
        const config = { 
            headers: { 
                'language': language || 'en',
                // 'x-zupee-env': 'cse',
                'x-zupee-source': 'web',
                // "z-stage-env-id":"stv-prya80a3bac",
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Package-Name': process.env.REACT_APP_APPPACKAGENAME || 'pwa.verticalbyzupee.com',
                'appname': process.env.REACT_APP_APP_NAME || 'pwa.verticalbyzupee.com',
            } 
        };
   
        const body = {
            phoneNumber: mobileNumber,
            action,
            userResendOtp,
            appPackageName: "com.eight.network.android.vertical",
        };

        try {
            const response = await axios.post(fullUrl, body, config);
            
            if(response.status === 200){
                return response.data;
            }else{
                console.log("error otp api response", response.data);
                throw new Error(response.data.message || 'OTP request failed');
            }
        } catch (error: any) {
            console.log("error otp api catch", error);
            if (error.response) {
                console.log("OTP API Error Details:", {
                    status: error.response.status,
                    statusText: error.response.statusText,
                    data: error.response.data,
                    headers: error.response.headers
                });
                
                // Provide more specific error message
                if (error.response.status === 401) {
                    throw new Error('Unauthorized: Please check API configuration and headers');
                }
            } else if (error.request) {
                console.log("OTP API Request Error:", error.request);
                throw new Error('Network error: Could not reach the server');
            }
            throw error;
        }


    }, []);
   
    return { requestOtp };
}

export default useSendOtp;
